import React from "react";

function PageHeader({ title, subtitle, children, className = "" }) {
    return (
        <div className={`flex justify-between items-center mb-8 ${className}`}>
            <div>
                <h1 className="text-2xl font-bold">{title}</h1>
                {subtitle && <p className="text-white/60">{subtitle}</p>}
            </div>
            {children && (
                <div className="flex items-center gap-4">{children}</div>
            )}
        </div>
    );
}

export default PageHeader;
